export default __webpack_public_path__ + "static/media/global-onboarding-v2.766d2a13.png";